import { render } from "./categories-list.vue?vue&type=template&id=25fb8f92"
import script from "./categories-list.vue?vue&type=script&lang=js"
export * from "./categories-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__